import { useEffect, useId, useState } from "react";
import { tsParticles } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";

let enginePromise = null;
function ensureEngine() {
  if (!enginePromise) enginePromise = loadSlim(tsParticles);
  return enginePromise;
}

export default function ParticleField({ density = 55, className = "" }) {
  const rawId = useId();
  const id = "p" + rawId.replace(/[^a-zA-Z0-9]/g, "");
  const [reduced] = useState(
    () => typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );

  useEffect(() => {
    if (reduced) return;
    let container;
    let cancelled = false;
    ensureEngine()
      .then(() =>
        tsParticles.load({
          id,
          options: {
            fullScreen: { enable: false },
            fpsLimit: 60,
            detectRetina: true,
            particles: {
              number: { value: density, density: { enable: true, area: 900 } },
              color: { value: ["#ffffff", "#d4af37", "#c0c0c0"] },
              opacity: { value: { min: 0.05, max: 0.35 } },
              size: { value: { min: 0.4, max: 1.6 } },
              links: { enable: true, distance: 130, color: "#3a3a3f", opacity: 0.18, width: 1 },
              move: { enable: true, speed: 0.35, outModes: { default: "out" } },
            },
            interactivity: {
              events: { onHover: { enable: true, mode: "grab" } },
              modes: { grab: { distance: 160, links: { opacity: 0.4 } } },
            },
          },
        })
      )
      .then((c) => {
        if (cancelled) c?.destroy();
        else container = c;
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      container?.destroy();
    };
  }, [id, density, reduced]);

  if (reduced) return null;
  return <div id={id} className={className} />;
}
